import { useState, useEffect } from "react";
import style from "./style.module.scss";

function Marquee({ page, text }) {
  const [content, setContent] = useState("test");

  useEffect(() => {
    const content = [];
    if (!page | !text) return;
    const ourText = text[page]?.marquee;

    let textContent = <div className={style.text}>{ourText}</div>;
    let divider = <div className={style.divider} />;

    [...Array(50)].forEach((t) => {
      content.push(textContent);
      content.push(divider);
    });

    setContent(content);
  }, [page, text]);

  return (
    <div className={style.Marquee + " row"}>
      <marquee>
        <div className={style.textCnt}>{content}</div>
      </marquee>
      {/* <div className={style.buttonCnt}>
            <div className={style.button}>
                IK DOE ZEKER MEE
            </div>
        </div> */}
    </div>
  );
}

export default Marquee;
